export type OrderDirection = "Ascending" | "Descending";

export default interface SearchParams {
  id?: number;
  query?: string;
  pageNumber?: number;
  pageSize?: number;
  filters?: string[];
  orderBy?: string;
  orderDirection?: OrderDirection;
}

export const defaultParams: SearchParams = {
  query: "",
  pageNumber: 1,
  pageSize: 10,
  filters: []
};
